import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  CalendarDays, 
  CalendarClock, 
  FileText, 
  User, 
  LogOut,
  X
} from 'lucide-react';
import KeycloakService from '../../config/KeycloakService';
import { 
  USER_PROFILE, 
  APPOINTMENTS, 
  RESERVATIONS, 
  INVOICES 
} from '../../../utilities/constants/AccountScreen';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const navItems = [
    { name: 'Overview', path: '/account', icon: <LayoutDashboard size={20} />, end: true },
    { name: 'My Profile', path: `/account/${USER_PROFILE}`, icon: <User size={20} /> },
    { name: 'Appointments', path: `/account/${APPOINTMENTS}`, icon: <CalendarClock size={20} /> },
    { name: 'Reservations', path: `/account/${RESERVATIONS}`, icon: <CalendarDays size={20} /> },
    { name: 'Invoices', path: `/account/${INVOICES}`, icon: <FileText size={20} /> },
  ];

  const handleLogout = () => {
    KeycloakService.doLogout(location);
  };

  return (
    <>
      {/* Mobile Overlay */}
      <div 
        className={`fixed inset-0 z-[60] bg-black/50 transition-opacity lg:hidden ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={toggleSidebar}
      />

      <aside 
        className={`fixed lg:sticky top-0 lg:top-16 left-0 z-[70] w-64 h-screen lg:h-[calc(100vh-4rem)] bg-white dark:bg-slate-900 border-r border-slate-200 dark:border-slate-800 transition-transform duration-300 ease-in-out lg:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <div className="flex flex-col h-full">
            {/* Header */}
            <div className="h-16 flex items-center justify-between px-6 border-b border-slate-200 dark:border-slate-800">
                <span className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent font-serif tracking-wide">
                    Member Portal
                </span>
                <button onClick={toggleSidebar} className="lg:hidden text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200">
                    <X size={24} />
                </button>
            </div>

            {/* Nav Links */}
            <nav className="flex-1 overflow-y-auto py-6 px-3 space-y-1">
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        end={item.end}
                        onClick={() => toggleSidebar(false)} // Close on mobile select
                        className={({ isActive }) => `
                            flex items-center gap-3 px-3 py-3 rounded-lg transition-all duration-200 group
                            ${isActive 
                                ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 font-medium' 
                                : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-200'
                            }
                        `}
                    >
                        {item.icon}
                        <span>{item.name}</span>
                    </NavLink>
                ))}
            </nav>

            {/* Footer / Logout */}
            <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                <button 
                  onClick={handleLogout}
                  className="flex items-center gap-3 w-full px-3 py-3 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/10 rounded-lg transition-colors"
                >
                   <LogOut size={20} />
                   <span>Sign Out</span>
                </button>
            </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
